import { createRoot } from 'react-dom/client'

import { loadData } from 'data/load'
import Store from 'store'
import OverlayRoot from 'ui/utils/OverlayManager'

import { Api } from '@/api'
import { BuildListProfile } from '@/common'
import { BuildListTool } from '@/components/embeds/BuildList'
import { validateState } from '@/logic/validation'

document.addEventListener('DOMContentLoaded', async () => {
  const root = document.querySelector('.poeplanner-build-list')
  if (!root) return

  await loadData()

  const api = new Api()

  const profile = await validateState(JSON.parse((await api.load(BuildListProfile)).data))
  const data = profile?.embeds?.find((e) => e.id === 1)

  if (!data || data.type !== 'buildlist') return

  const store = new Store(profile)

  const mxrlMain = root.closest('#mxrl-main') as HTMLElement
  mxrlMain.style.display = 'flex'
  mxrlMain.style.flexDirection = 'column'
  mxrlMain.style.minHeight = 'calc(100vh - 150px)'
  root.classList.add('poeplanner-wrapper')
  createRoot(root).render(
    <Store.Provider store={store}>
      <OverlayRoot>
        <BuildListTool data={data} />
      </OverlayRoot>
    </Store.Provider>
  )
})
